import {Dispatch} from "redux";
import {ErrorDto, getErrorDtoFromApiError} from "../../../models/dtos/error.dto";
import {GET_CONTENTS_FAIL, GET_CONTENTS_RESET, GET_CONTENTS_START, GET_CONTENTS_SUCCESS,} from "./constants";
import {getContentsRequest} from "./repository";
import {
  GetContentsFailAction,
  GetContentsResetAction,
  GetContentsStartAction,
  GetContentsSuccessAction,
} from "./types";

const getContentsStartAction = (): GetContentsStartAction => {
  return {
    type: GET_CONTENTS_START,
  };
}
const getContentsSuccessAction = (payload: Map<string, string>): GetContentsSuccessAction => {
  return {
    type: GET_CONTENTS_SUCCESS,
    payload: payload,
  };
}
const getContentsFailAction = (error: ErrorDto): GetContentsFailAction => {
  return {
    type: GET_CONTENTS_FAIL,
    error: error,
  };
}
const getContentsResetAction = (): GetContentsResetAction => {
  return {
    type: GET_CONTENTS_RESET,
  };
}

export const getContents = () => async (
  dispatch: Dispatch
) => {
  try {
    dispatch(getContentsStartAction());
    const contents = await getContentsRequest();
    const contentMap: Map<string, string> = new Map<string, string>();
    contents.forEach(c => contentMap.set(c.contentKey, c.contentValue));
    dispatch(getContentsSuccessAction(contentMap));
  } catch (error) {
    dispatch(getContentsFailAction(getErrorDtoFromApiError(error)));
  }
};

export const getContentsReset = () => (
  dispatch: Dispatch
) => {
  dispatch(getContentsResetAction());
};
